import React, { memo } from "react";
import { INTERACTIVE_CLASSES } from "../../interactive-product-classes.js";
import { computePositionStyles } from "../../interactive-element.js";
import { InteractiveHoverElement } from "./InteractiveHoverElement.jsx";
import { useProductLightboxControls } from "../product-lightbox/product-lightbox-context.js";
import { useShowingAllZones } from "../../show-all-zones/show-all-zones.jsx";

/**
 * Zóna u produktu, na kterou se dá najet.
 */
export const InteractiveProductZone = memo(({ product }) => {
	const { uid, id, buttonText, buttonLink, followingRequestBody } =
		product;

	const positionStyles = computePositionStyles(product);

	const { showProductLightboxAtProduct } = useProductLightboxControls();

	const handleClick = () => showProductLightboxAtProduct(uid);

	// z BE může přijít null za IDčko, v tom případě nepřidáváme anchor
	const usedZoneId = id ?? undefined;

	const { showingAllZones } = useShowingAllZones();

	const forceVisibilityClass = showingAllZones
		? INTERACTIVE_CLASSES.ENABLE_PRODUCT_VISIBILITY
		: "";

	const fullContainerClassname = `${INTERACTIVE_CLASSES.INTERACTIVE_PRODUCT} ${forceVisibilityClass}`;

	const standardContent = (
		<div
			id={usedZoneId}
			className={fullContainerClassname}
			style={positionStyles}
			onClick={handleClick}
		>
			<InteractiveHoverElement
				bottomButtonText={buttonText}
				buttonLink={buttonLink}
				productUid={uid}
				followingRequestBody={followingRequestBody}
			/>
		</div>
	);

	return standardContent;
});
